import { Route, Switch, useRouteMatch } from 'react-router-dom'

import BranchProductPage from '@pages/Branch/ProductPage'
import BranchProductSalePage from '@pages/Branch/ProductSalePage'
import NotFoundPage from '@pages/Error/NotFoundPage'

export default function BranchProductRouter(): JSX.Element {
  const { url } = useRouteMatch()

  return (
    <Switch>
      <Route path={`${url}/list`}>
        <BranchProductPage />
      </Route>
      <Route path={`${url}/sale`}>
        <BranchProductSalePage />
      </Route>
      <Route>
        <NotFoundPage />
      </Route>
    </Switch>
  )
}
